import React from "react";
import { useSelector } from "react-redux";
import { URL } from "../../../Redux/common/url";

const CourceImage = () => {
  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  console.log(get_product_list?.proLists);

  return (
    <div className="container">
      <div className="image-container mt-5 rounded">
        <div className=" row justify-content-center ">
          <div className="col-12">
            <img
              className="img-fluid"
              src={URL?.API_BASE_URL + get_product_list?.proLists?.image}
              alt=""
            />
          </div>
        <div className="col-12">
  <p className="text-white mt-auto mb-2 image-container-title">
    {get_product_list?.proLists?.name}
  </p>

  <div
    className="text-white mt-auto mb-2 image-container-title"
    dangerouslySetInnerHTML={{
      __html: get_product_list?.proLists?.description || "",
    }}
  />

  {get_product_list?.buyorder == null && (
    <a
      href={
        "https://manglamart.com/product/" +
        get_product_list?.proLists?.product_id?.pro_sulg
      }
      target="_blank"
      className="text-white chapters-container-link"
    >
      Buy now
    </a>
  )}
</div>
        </div>
      </div>
    </div>
  );
};

export default CourceImage;
